"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.F = exports.Serial = exports.delay = exports.digitalRead = exports.millis = void 0;
function millis() {
    return Date.now();
}
exports.millis = millis;
function digitalRead(pin) {
    return false;
}
exports.digitalRead = digitalRead;
function delay(timeoutMs) {
    return new Promise((res, rej) => { setTimeout(() => { res(true); }, timeoutMs); });
}
exports.delay = delay;
exports.Serial = {
    begin: (baudRate) => {
    },
    print: (value) => {
        console.log(value);
    },
    println: (value) => {
        console.log(value);
    }
};
function F(val) { return val; }
exports.F = F;
;
//# sourceMappingURL=ArduinoGlobals.js.map